jQuery_T4NT(document).ready(function($) {

     /**
     *  Variant selection changed
     *  data-variant-toggle="{{ variant.id }}"
     */
	   $( document ).on( "variant:changed", function( evt ) {
	     // console.log( evt.currentVariant );
	     // $('[data-variant-toggle]').hide(0);
	     // $('[data-variant-toggle="'+evt.currentVariant.id+'"]').show(0);
	   });
});
document.addEventListener("DOMContentLoaded", function () {
  const toggleButtons = document.querySelectorAll(".toggle-description");

  toggleButtons.forEach(function (btn) {
    btn.addEventListener("click", function () {
      const container = btn.closest(".collection-description");
      container.classList.toggle("expanded");
      btn.textContent = container.classList.contains("expanded") ? "View Less" : "View More";
    });
  });
});